import Vue from 'vue'

export default {
    showSuccess (title, message) {
        Vue.swal({
            text: message,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            type: 'success',
            title: title,
            showCloseButton: false,
            animation: true
        })
    },
    showFailure (title, message) {
        Vue.swal({
            text: message,
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            type: 'error',
            title: title,
            showCloseButton: false,
            animation: true
        })
    },
    confirmAction (title, message, cancelButton, confirmButton) {
    }
}



// WEBPACK FOOTER //
// ./src/utils/OAlert/OAlert.js